/**
 * CSV download for bulk reserved import row failures (same columns as modal error reports).
 *
 * @param {string} [batchId]
 * @param {{ rowIndex?: number, excelRow?: number|string, error?: string }[]} failedResults
 * @param {string} [filenamePrefix]
 */
export function downloadBulkReservedImportErrorCsv(
  batchId,
  failedResults,
  filenamePrefix = "bulk_reserved_import_errors",
) {
  const header = "rowIndex,excelRow,error\n";
  const body = failedResults
    .map((r) => {
      const err = String(r.error ?? "").replace(/"/g, '""');
      const excel =
        r.excelRow != null && r.excelRow !== "" ? String(r.excelRow) : "";
      return `${r.rowIndex},${excel},"${err}"`;
    })
    .join("\n");
  const blob = new Blob([header + body], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const safeId = String(batchId || "batch")
    .replace(/[^\w.-]+/g, "_")
    .slice(0, 80);
  a.download = `${filenamePrefix}_${safeId}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
